import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import vueAxios from "vue-axios";
import Carousel3d from 'vue-carousel-3d';
import titleMix from "./mixins/titleMix";

Vue.use(vueAxios, axios);
Vue.use(Carousel3d);

Vue.mixin({
  data: () => {
    return {
      client: async () => {
        let auth = localStorage.getItem("showroom");
        if (auth) {
          return auth;
        } else {
          let id = new Date().getTime();
          let root = "/auth";
          if(process.env.VUE_APP_DEV === 'true') root = `http://${process.env.VUE_APP_SERVER}/auth`;
          let res = await axios.post(root, {}, { headers: { token: id } });
          if(res.status == 204) {
            localStorage.setItem("showroom", id);
            window.location.reload();
          }
        }
      }
    };
  }
});

Vue.mixin(titleMix);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
